// eslint-disable-next-line filenames/match-exported
import { SVGProps } from "react";

const SoftwarePackagesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 3.8C2 2.80589 2.80589 2 3.8 2H6.2C7.19411 2 8 2.80589 8 3.8V6.2C8 7.19411 7.19411 8 6.2 8H3.8C2.80589 8 2 7.19411 2 6.2V3.8Z"
      fill="currentColor"
    />
    <path
      d="M2 17.8C2 16.8059 2.80589 16 3.8 16H6.2C7.19411 16 8 16.8059 8 17.8V20.2C8 21.1941 7.19411 22 6.2 22H3.8C2.80589 22 2 21.1941 2 20.2V17.8Z"
      fill="currentColor"
    />
    <path
      d="M2 10.8C2 9.80589 2.80589 9 3.8 9H6.2C7.19411 9 8 9.80589 8 10.8V13.2C8 14.1941 7.19411 15 6.2 15H3.8C2.80589 15 2 14.1941 2 13.2V10.8Z"
      fill="currentColor"
    />
    <path
      d="M9 3.8C9 2.80589 9.80589 2 10.8 2H13.2C14.1941 2 15 2.80589 15 3.8V6.2C15 7.19411 14.1941 8 13.2 8H10.8C9.80589 8 9 7.19411 9 6.2V3.8Z"
      fill="currentColor"
    />
    <path
      d="M9 17.8C9 16.8059 9.80589 16 10.8 16H13.2C14.1941 16 15 16.8059 15 17.8V20.2C15 21.1941 14.1941 22 13.2 22H10.8C9.80589 22 9 21.1941 9 20.2V17.8Z"
      fill="currentColor"
    />
    <path
      d="M9 10.8C9 9.80589 9.80589 9 10.8 9H13.2C14.1941 9 15 9.80589 15 10.8V13.2C15 14.1941 14.1941 15 13.2 15H10.8C9.80589 15 9 14.1941 9 13.2V10.8Z"
      fill="currentColor"
    />
    <path
      d="M16 3.8C16 2.80589 16.8059 2 17.8 2H20.2C21.1941 2 22 2.80589 22 3.8V6.2C22 7.19411 21.1941 8 20.2 8H17.8C16.8059 8 16 7.19411 16 6.2V3.8Z"
      fill="currentColor"
    />
    <path
      d="M16 17.8C16 16.8059 16.8059 16 17.8 16H20.2C21.1941 16 22 16.8059 22 17.8V20.2C22 21.1941 21.1941 22 20.2 22H17.8C16.8059 22 16 21.1941 16 20.2V17.8Z"
      fill="currentColor"
    />
    <path
      d="M16 10.8C16 9.80589 16.8059 9 17.8 9H20.2C21.1941 9 22 9.80589 22 10.8V13.2C22 14.1941 21.1941 15 20.2 15H17.8C16.8059 15 16 14.1941 16 13.2V10.8Z"
      fill="currentColor"
    />
    <path
      d="M3 4.2C3 3.53726 3.53726 3 4.2 3H5.8C6.46274 3 7 3.53726 7 4.2V5.8C7 6.46274 6.46274 7 5.8 7H4.2C3.53726 7 3 6.46274 3 5.8V4.2Z"
      fill="white"
    />
    <path
      d="M10 4.2C10 3.53726 10.5373 3 11.2 3H12.8C13.4627 3 14 3.53726 14 4.2V5.8C14 6.46274 13.4627 7 12.8 7H11.2C10.5373 7 10 6.46274 10 5.8V4.2Z"
      fill="white"
    />
    <path
      d="M17 4.2C17 3.53726 17.5373 3 18.2 3H19.8C20.4627 3 21 3.53726 21 4.2V5.8C21 6.46274 20.4627 7 19.8 7H18.2C17.5373 7 17 6.46274 17 5.8V4.2Z"
      fill="white"
    />
    <path
      d="M3 11.2C3 10.5373 3.53726 10 4.2 10H5.8C6.46274 10 7 10.5373 7 11.2V12.8C7 13.4627 6.46274 14 5.8 14H4.2C3.53726 14 3 13.4627 3 12.8V11.2Z"
      fill="white"
    />
    <path
      d="M3 18.2C3 17.5373 3.53726 17 4.2 17H5.8C6.46274 17 7 17.5373 7 18.2V19.8C7 20.4627 6.46274 21 5.8 21H4.2C3.53726 21 3 20.4627 3 19.8V18.2Z"
      fill="white"
    />
    <path
      d="M10 11.2C10 10.5373 10.5373 10 11.2 10H12.8C13.4627 10 14 10.5373 14 11.2V12.8C14 13.4627 13.4627 14 12.8 14H11.2C10.5373 14 10 13.4627 10 12.8V11.2Z"
      fill="white"
    />
    <path
      d="M10 18.2C10 17.5373 10.5373 17 11.2 17H12.8C13.4627 17 14 17.5373 14 18.2V19.8C14 20.4627 13.4627 21 12.8 21H11.2C10.5373 21 10 20.4627 10 19.8V18.2Z"
      fill="white"
    />
    <path
      d="M17 11.2C17 10.5373 17.5373 10 18.2 10H19.8C20.4627 10 21 10.5373 21 11.2V12.8C21 13.4627 20.4627 14 19.8 14H18.2C17.5373 14 17 13.4627 17 12.8V11.2Z"
      fill="white"
    />
    <path
      d="M17 18.2C17 17.5373 17.5373 17 18.2 17H19.8C20.4627 17 21 17.5373 21 18.2V19.8C21 20.4627 20.4627 21 19.8 21H18.2C17.5373 21 17 20.4627 17 19.8V18.2Z"
      fill="white"
    />
  </svg>
);

export default SoftwarePackagesIcon;
